import { render, staticRenderFns } from "./SchoolPurchaseRank.vue?vue&type=template&id=7a95e262&scoped=true&"
import script from "./SchoolPurchaseRank.vue?vue&type=script&lang=js&"
export * from "./SchoolPurchaseRank.vue?vue&type=script&lang=js&"
import style0 from "./SchoolPurchaseRank.vue?vue&type=style&index=0&id=7a95e262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a95e262",
  null
  
)

export default component.exports